import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { esEstrellasCalificacionValidas } from '../domain/calificacionRules.js';

export function createCalificacionesRepository({ getFirebase }) {
  async function yaCalificoVendedor({ vendedorUid, compradorUid }) {
    const v = String(vendedorUid || '').trim();
    const c = String(compradorUid || '').trim();
    if (!v || !c) return false;
    const { db } = getFirebase();
    const ref = doc(db, 'usuarios', v, 'resenas_recibidas', c);
    const snap = await getDoc(ref);
    return snap.exists();
  }

  async function enviarResenaTarjetaServicio({ profesionalUid, tarjetaId, estrellas, reseñaTexto = '' }) {
    if (!esEstrellasCalificacionValidas(estrellas)) {
      throw new Error('Elegí una calificación de 1 a 5.');
    }
    const { fns } = getFirebase();
    if (!fns) throw new Error('Functions no está inicializado.');
    const call = httpsCallable(fns, 'enviarResenaTarjetaServicio');
    const res = await call({
      profesionalUid: String(profesionalUid || '').trim(),
      tarjetaId: String(tarjetaId || '').trim(),
      estrellas,
      reseñaTexto: reseñaTexto != null ? String(reseñaTexto).trim().slice(0, 500) : '',
    });
    return res?.data || null;
  }

  async function enviarCalificacionVendedor({ vendedorUid, estrellas, productoId }) {
    if (!esEstrellasCalificacionValidas(estrellas)) {
      throw new Error('Elegí una calificación de 1 a 5.');
    }
    const { fns } = getFirebase();
    if (!fns) throw new Error('Functions no está inicializado.');
    const call = httpsCallable(fns, 'enviarCalificacionVendedor');
    const res = await call({
      vendedorUid: String(vendedorUid || '').trim(),
      estrellas,
      productoId: productoId != null ? String(productoId).trim() : '',
    });
    return res?.data || null;
  }

  return {
    yaCalificoVendedor,
    enviarCalificacionVendedor,
    enviarResenaTarjetaServicio,
  };
}
